/* eslint-disable */
import React from 'react';
import { SingleSelect } from '../_shared/SingleSelect';

const OPTIONS = [{ id: 'hard' }, { id: 'partly' }, { id: 'none' }];

function Page() {
  return (
    <SingleSelect
      page="hairstyle-women-barber-struggle"
      progress={80}
      field="hairstyleWomenBarberStruggle"
      setter="setHairstyleWomenBarberStruggle"
      ns="hairstyleWomenBarberStruggle"
      options={OPTIONS}
      hasSubtitle
    />
  );
}

export default Page;
